import useDoExerciseStore from "../../store/exerciseStore"
import { Card } from "../ui/card"
import PraiseMessage from "./PraiseMessage"
import { Button } from "../ui/button"
import { useNavigate, useLocation } from "react-router-dom"
import { RefreshCcw, ArrowLeft } from "lucide-react"

export default function Result () {
  const { result, redo} = useDoExerciseStore()
  const location = useLocation()
  const navigate = useNavigate()
  return (
    <Card className="p-4 text-center shadow-sm space-y-4 bg-gradient-to-br from-[#CCFFAA] to-[#1E5B53]">
  <h1 className="font-black text-2xl text-white">Bạn đã hoàn thành bài tập</h1>
  <h2 className="font-bold text-xl text-blue-950">Điểm số</h2>
  <p className="text-2xl text-white">{result.score}</p>
  <PraiseMessage score={result.score} />
  <div className="space-x-8">
    <Button
    className="rounded-lg"

    onClick={() => redo()}><RefreshCcw /> {" "} Thử lại</Button>
    <Button
    className="rounded-lg"
    variant="secondary"
    onClick={() => navigate(location.pathname, { replace: true })}><ArrowLeft /> {" "}Quay về bài học</Button>
  </div>
</Card>

  )
}
